export const en = {
  filterBy: 'Filter By',
  clear: 'Clear',
};
